import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57201224"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "umbraco-forms-label" }
const _hoisted_2 = { class: "form-control radiobuttonlist" }
const _hoisted_3 = ["for"]

import { PropType } from "vue";
import UmbracoFormInput from "@/components/umbraco-forms/inputs/UmbracoFormInput.vue";
import { IUmbracoFormField } from "@/models/umbraco-forms/IUmbracoFormField";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoFormSingleChoice',
  props: {
  field: {
    type: Object as PropType<IUmbracoFormField>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.field.caption), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.field.preValues, (preValue) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "form-control-radiobutton radio-button",
          key: preValue.value
        }, [
          _createElementVNode("label", {
            for: `${__props.field.id}-${preValue.value}`,
            class: "radio-button__container"
          }, [
            _createVNode(UmbracoFormInput, {
              type: "radio",
              field: __props.field,
              value: preValue.value,
              id: `${__props.field.id}-${preValue.value}`
            }, null, 8, ["field", "value", "id"]),
            _createTextVNode(" " + _toDisplayString(preValue.caption), 1)
          ], 8, _hoisted_3)
        ]))
      }), 128))
    ])
  ], 64))
}
}

})